import { render, staticRenderFns } from "./taskEdit.vue?vue&type=template&id=0db16eff&scoped=true&"
import script from "./taskEdit.vue?vue&type=script&lang=ts&"
export * from "./taskEdit.vue?vue&type=script&lang=ts&"
import style0 from "./taskEdit.vue?vue&type=style&index=0&id=0db16eff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db16eff",
  null
  
)

export default component.exports